module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "card-product",
    on: {
      "click": function($event) {
        _vm.goTo('products')
      }
    }
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.product.urlImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    ref: "discount",
    staticClass: "card-discount",
    style: (("background-color:" + (_vm.globalColors.hover) + ";")),
    on: {
      "mouseover": function($event) {
        _vm.changeBG('primary')
      },
      "mouseout": function($event) {
        _vm.changeBG('hover')
      }
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.discountPercentage) + "%\n\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content-title"
  }, [_c('p', {
    attrs: {
      "title": _vm.product.name
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.getProductName) + "\n\t\t\t")]), _vm._v(" "), _c('p', {
    attrs: {
      "title": _vm.product.description
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.capitalizeDescription) + "\n\t\t\t")])]), _vm._v(" "), (_vm.product.price) ? _c('p', {
    staticClass: "text-price"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.getCurrencySymbol) + _vm._s(_vm._f("priceFormat")(_vm.product.price)) + "\n\t\t")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-discount",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.getCurrencySymbol) + _vm._s(_vm._f("priceFormat")(_vm.getPriceDiscount)) + "\n\t\t")])]), _vm._v(" "), (_vm.noStock) ? _c('div', {
    staticClass: "wraper-is-not-stock"
  }, [_c('span', {
    staticClass: "text-is-not"
  }, [_vm._v("AGOTADO")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-495d9166","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product-card.vue
// module id = 1109
// module chunks = 38